module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b1efa4237175d3c78052aa209a7ded25.png";